module.exports = __webpack_public_path__ + "static/media/apache.083926f5.svg";